export const zh = {
  mri: {
    before: {
      whatHappens: 'MRI检查前，团队会确认检查对您是否安全，并说明需要做的准备。您可能会被问到既往手术、体内植入物或金属、怀孕情况、正在服用的药物、肾脏问题，以及以前是否对造影剂有过反应。根据检查类型，您可能需要换上病号服、取下金属物品，或放置静脉留置针以便使用造影剂。',
      whyItMayHappen: 'MRI使用很强的磁场，因此安全筛查非常重要。有些检查还会使用造影剂，使某些组织显示得更清楚。具体准备取决于扫描部位以及您的团队希望通过检查回答的临床问题。',
      whatTeamIsDoing: '影像团队会审核检查申请，确认MRI是否合适且安全，核对正确的检查，并决定是否需要特殊准备、造影剂或额外监测。',
      variationNote: '并不是每个人都需要造影剂、静脉留置针或相同的准备。如果您有植入装置、体内金属碎片、严重幽闭恐惧或其他顾虑，团队可能需要更多资料后再决定如何安全进行检查。',
      nextSteps: [
        { id: 'ready', title: '按计划进行MRI检查', when: '安全检查和准备完成后' },
        { id: 'extra-checks', title: '进一步安全核查或调整计划', description: '团队可能需要查看植入装置资料、补充临床信息，或考虑其他影像检查方式。', when: '安全筛查发现需要进一步确认的问题时' },
      ],
    },
    during: {
      whatHappens: '检查时，您通常会躺在一张移动的检查床上，床会进入MRI扫描仪。扫描部位周围可能会放置线圈。机器会发出较大的敲击声或嗡鸣声，因此通常会提供听力保护。您需要尽量保持不动，有时会被要求短暂屏住呼吸。放射技师在整个检查过程中都能看到并听到您。',
      whyItMayHappen: '保持不动有助于获得清晰图像。不同的扫描序列会以不同方式显示组织，所以检查可能包括几组短时间的图像采集。有些MRI在能提供更多信息时会使用造影剂。',
      whatTeamIsDoing: '放射技师会帮助您摆好体位、运行扫描序列、检查图像质量并持续观察您的情况。如果图像或临床问题提示需要更多信息，他们可能会与放射科医生讨论是否增加扫描序列。',
      variationNote: 'MRI所需时间和体验会因扫描部位和检查类型而不同。并不是每个人都需要造影剂。有些人会因为疼痛、活动困难或幽闭恐惧需要额外支持，少数人可能需要在单独的临床计划下接受镇静。',
      nextSteps: [
        { id: 'complete', title: '扫描完成', when: '所需图像全部获取后' },
        { id: 'additional-images', title: '补充少量图像', description: '如果需要更多细节，放射技师可能会重复或增加一些扫描序列。', when: '图像质量或扫描发现提示需要更多图像时' },
      ],
    },
    after: {
      whatHappens: 'MRI结束后，完成必要的即时检查后您通常可以离开扫描区。如果放置了静脉留置针，可能会将其移除。之后影像会被审核，并把报告发送给申请检查的医生或服务团队。',
      whyItMayHappen: 'MRI图像通常需要由放射科医生或其他受过相应训练的专业人员仔细解读，所以进行扫描的人员可能无法立即告诉您结果。',
      whatTeamIsDoing: '影像团队会确认检查是否完整，整理图像供报告使用，并通过常规临床流程发送结果。申请检查的团队负责向您解释结果对您治疗和护理的意义。',
      variationNote: '不同服务的结果通知方式和时间可能不同，也取决于检查的紧急程度。如果检查中使用了镇静或其他治疗，您可能还会收到单独的恢复和离院指导。',
      nextSteps: [
        { id: 'routine-results', title: '由申请检查的团队告知结果', description: '报告会结合您的其他临床信息一起评估。', when: '大多数计划进行的MRI检查' },
        { id: 'urgent-review', title: '更早进行临床评估', description: '如果发现重要的意外结果，可按照当地紧急处理流程及时安排评估。', when: '影像团队发现需要更紧急关注的问题时' },
      ],
    },
  },
  ct: {
    before: {
      whatHappens: 'CT检查前，团队会确认您要做的具体检查以及是否需要准备。您可能会被问到怀孕、过敏、肾脏问题、糖尿病用药，以及以前是否对造影剂有过反应。根据检查类型，您可能需要暂时禁食、喝水或口服造影剂、换衣服，或放置静脉留置针。',
      whyItMayHappen: 'CT使用X射线生成详细的横断面图像。有些CT会使用造影剂，让血管、器官或其他结构显示得更清楚。安全核查和准备有助于团队选择最合适的检查方式。',
      whatTeamIsDoing: '影像团队会审核申请、确认正确的检查，并决定是否需要造影剂、血液检查资料或其他安全措施。',
      variationNote: '不同CT检查的准备差别很大。并不是每个人都需要造影剂、禁食、验血或静脉留置针。请以您自己预约通知中的具体要求为准。',
      nextSteps: [
        { id: 'ready', title: '按计划进行CT检查', when: '所需核查和准备完成后' },
        { id: 'adjust-plan', title: '调整检查方案', description: '团队可能会调整造影剂使用、获取更多资料，或选择其他影像检查方式。', when: '需要先考虑安全问题或其他临床因素时' },
      ],
    },
    during: {
      whatHappens: 'CT检查时，您会躺在检查床上，床会穿过一个较短的环形扫描仪。扫描本身通常很快。放射技师可能会请您保持不动或短暂屏住呼吸。如果通过静脉留置针注射造影剂，您可能会短暂感到身体发热或口中有特殊味道。',
      whyItMayHappen: '保持不动和屏气可以减少图像中的运动伪影。有些检查使用造影剂，是为了让某些结构或血管更清楚。',
      whatTeamIsDoing: '放射技师会帮助您摆好体位、运行扫描、检查图像并在整个检查中观察您。他们会按计划的方案进行，并在临床问题或图像需要时作出调整。',
      variationNote: '有些CT只需几分钟，较复杂的检查可能更久。并不是每个人都会使用造影剂，对造影剂的感觉也因人而异。',
      nextSteps: [
        { id: 'complete', title: '扫描完成', when: '所需图像全部获取后' },
        { id: 'extra-images', title: '如有需要补拍图像', description: '有时可能需要再采集一小组图像。', when: '首批图像未能充分回答临床问题时' },
      ],
    },
    after: {
      whatHappens: 'CT结束后，通常在即时检查完成后就可以离开。如果使用了造影剂，团队可能会根据当地做法和您的情况让您短暂留观。影像随后会被审核，并将报告发送给申请检查的医生或服务团队。',
      whyItMayHappen: 'CT会产生大量图像，需要结合临床问题进行解读，因此正式结果通常稍后提供，而不是由扫描室的放射技师立即告知。',
      whatTeamIsDoing: '影像团队会确认检查完整，整理图像供报告使用，并通过适当的临床流程传递结果。',
      variationNote: '结果提供的时间和方式可能不同。紧急CT可能很快被审核，而常规门诊检查可能在之后的门诊、信件、电话或当地其他流程中讨论。',
      nextSteps: [
        { id: 'routine-results', title: '由申请检查的团队告知结果', description: '临床医生会结合您的症状和其他检查解读报告。', when: '大多数计划进行的CT检查' },
        { id: 'urgent-review', title: '更早进行临床评估', description: '如果发现重要的意外结果，可按照当地紧急处理流程及时安排评估。', when: '检查发现需要更紧急关注的问题时' },
      ],
    },
  },
  ultrasound: {
    before: {
      whatHappens: '超声检查前，请按照您这项检查的具体准备要求进行。有些检查需要膀胱充盈，有些需要禁食，很多则不需要特殊准备。团队会确认您的身份信息、检查部位和检查内容。',
      whyItMayHappen: '不同超声检查需要不同准备，因为这样可能更容易看清器官或其他结构。超声使用高频声波，而不是X射线。',
      whatTeamIsDoing: '影像团队会审核申请、确认正确的检查，并检查是否已完成获得有效图像所需的准备。',
      variationNote: '超声检查种类很多。腹部、盆腔、血管、孕期以及其他超声的准备和检查方式都可能不同，因此请以您自己的预约说明为准。',
      nextSteps: [
        { id: 'ready', title: '进行超声检查', when: '所需准备完成后' },
        { id: 'preparation-issue', title: '继续准备或调整检查', description: '团队可能会让您多等一会儿、多喝一些水，或讨论其他方案。', when: '现有准备仍不足以获得清晰图像时' },
      ],
    },
    during: {
      whatHappens: '很多超声检查会先在皮肤上涂凝胶，然后用手持探头在检查区域移动。您可能会被要求改变体位、吸气或短暂屏气。有些专门的检查会使用体内探头；如果与您有关，临床人员应先解释检查并取得您的同意。',
      whyItMayHappen: '探头发射并接收声波，从而形成身体内部结构的动态图像。改变体位或轻微加压有时可以帮助检查人员看得更清楚。',
      whatTeamIsDoing: '超声技师、放射科医生或其他受过训练的临床人员会获取所需图像、在需要时测量，并判断检查是否回答了临床问题。',
      variationNote: '检查过程会因扫描部位而有很大不同。有些超声结果可以在当场讨论，有些则需要进一步审核或与其他检查结合后才能给出。',
      nextSteps: [
        { id: 'complete', title: '检查完成', when: '所需图像和测量全部获取后' },
        { id: 'additional-views', title: '增加图像或改变检查方式', description: '临床人员可能会改变您的体位，或采用另一种超声方式以获得更清楚的信息。', when: '检查过程中需要更多信息时' },
      ],
    },
    after: {
      whatHappens: '大多数超声检查后，除非另有说明，您可以立即恢复日常活动。检查报告会被完成，并通过申请检查的服务所使用的流程发送。',
      whyItMayHappen: '图像和测量结果需要结合申请检查的原因来解读。根据检查类型，进行检查的人可能可以，也可能无法立即告诉您结果。',
      whatTeamIsDoing: '影像团队会完成检查记录和报告，并确保结果送达适当的临床团队。',
      variationNote: '不同服务和检查类型的结果告知方式和时间可能不同。如果发现需要紧急处理的问题，可以按当地紧急处理流程处理，而无需等到常规复诊。',
      nextSteps: [
        { id: 'routine-results', title: '由申请检查的团队告知结果', description: '结果会与您的其他临床信息一起评估。', when: '很多计划进行的超声检查' },
        { id: 'urgent-review', title: '更早进行临床评估', description: '如果发现重要的意外结果，可按照当地紧急处理流程及时安排评估。', when: '检查发现需要更紧急关注的问题时' },
      ],
    },
  },
  'day-surgery': {
    before: {
      whatHappens: '日间手术前，您可能需要进行术前评估，并收到关于禁食、用药、到院时间以及需要携带物品的说明。手术当天，工作人员通常会再次确认您的身份、计划进行的操作、知情同意，以及自评估以来是否有重要变化。',
      whyItMayHappen: '这些核查有助于团队确认计划中的操作可以尽可能安全地进行，并确保过敏、用药或健康状况变化等重要信息都是最新的。',
      whatTeamIsDoing: '团队会检查您的准备情况、确认计划，并确保所有参与人员都有所需信息。根据操作类型，您可能会见到护理人员、手术或操作团队以及麻醉医生。',
      variationNote: '准备要求会因操作、麻醉方式、您的病史和当地服务而不同。请遵循您自己医院提供的禁食和用药说明，因为它们可能与一般建议不同。',
      nextSteps: [
        { id: 'ready', title: '准备好继续', description: '您继续按计划进入日间手术流程。', when: '团队确认可以继续进行计划中的操作时' },
        { id: 'more-checks', title: '进一步检查或讨论', description: '团队可能需要更多资料、检查或由资深临床人员进一步评估后再决定下一步。', when: '操作前有问题需要进一步确认时' },
        { id: 'changed-plan', title: '计划发生变化', description: '有时操作可能需要延后、调整或重新安排。团队应向您解释原因以及接下来会发生什么。', when: '继续原计划并不合适时' },
      ],
    },
    'procedure-recovery': {
      whatHappens: '您可能会先放置静脉留置针，然后前往操作室或手术室。麻醉或镇静方式取决于操作和您已同意的计划。之后您通常会在恢复区停留一段时间，工作人员会监测您的情况，并在需要时处理疼痛、恶心等症状。',
      whyItMayHappen: '操作期间和之后的监测可以帮助团队了解您的恢复情况，并判断何时可以安全进入下一阶段。',
      whatTeamIsDoing: '操作、手术和麻醉团队会执行已商定的计划、监测您的情况并处理问题。恢复区工作人员随后会评估您的舒适度、生命体征、清醒程度、活动能力，以及在合适时是否能够进食、饮水或下床活动。',
      variationNote: '并不是每个人都需要相同的麻醉、药物、监测或恢复时间。有些操作很短，有些则需要更长时间的观察或额外治疗后才能考虑离院。',
      nextSteps: [
        { id: 'routine-recovery', title: '常规恢复', description: '您继续恢复，团队开始准备您离院。', when: '恢复情况符合预期时' },
        { id: 'longer-observation', title: '延长观察或治疗', description: '您可能需要在恢复区或日间手术单元多停留一段时间，直到症状或观察指标改善。', when: '您需要更多时间、药物、补液或监测时' },
        { id: 'admission', title: '住院', description: '少数情况下，团队可能建议留院过夜或转到其他临床区域。', when: '团队认为继续按日间手术方式护理并不安全时' },
      ],
    },
    home: {
      whatHappens: '离院前，团队可能会再次评估您的恢复情况，并说明用药、止痛、伤口或操作相关护理、后续安排以及出现担忧时应联系谁。根据麻醉或操作类型，您可能需要一位负责任的成年人接您回家或在一段时间内陪伴您。',
      whyItMayHappen: '离院计划有助于确保您能在家安全继续恢复，并知道哪些情况属于正常、需要注意什么以及何时寻求帮助。',
      whatTeamIsDoing: '团队会确认您符合当地离院标准，并确保重要说明、药物和联系方式清楚。团队也可能安排后续随访，或说明检查结果将如何告知您。',
      variationNote: '离院标准和恢复建议会因操作和麻醉方式而不同。不要假定其他患者收到的建议也适用于您，请遵循您自己的医疗团队提供的说明。',
      nextSteps: [
        { id: 'home', title: '回家恢复', description: '按照团队提供的恢复建议和用药方案继续恢复。', when: '您符合离院标准，并已安排好合适的交通和支持时' },
        { id: 'follow-up', title: '随访或结果', description: '您可能会接受门诊复查、电话随访、伤口检查或结果讨论。', when: '这些安排属于您的操作路径时' },
        { id: 'seek-help', title: '如有担忧请寻求帮助', description: '如果出现离院说明中提到的症状或其他担忧，请使用医院提供的联系方式和安全提示。', when: '您出现与离院建议相关的症状或担忧时' },
      ],
    },
  },
};
